module.exports = __webpack_public_path__ + "static/media/treeAVL-img.ca0e146d.png";